import { Component, Renderer2, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import 'rxjs/add/observable/of';

import { Slug } from 'ng2-slugify';
import { CompleterService, CompleterData, CompleterItem, CompleterCmp } from 'ng2-completer';
import { CustomCompleterData } from '../_helpers/custom-completer-data';

import { PortService } from '../_services/port.service';
import { EmitterService } from '../_services/emitter.service';
import { AuthService } from '../_services/auth.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.less'],

    encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
    @ViewChild("portCompleter") private portCompleter: CompleterCmp;

    private slug: Slug;

    pmo: string;
    protected port: any;
    public selectedPmo: any;
    protected selectedPort: any;

    protected portData: CustomCompleterData;
    protected pmoData: CustomCompleterData;
    protected pmoList: BehaviorSubject<any> = new BehaviorSubject([]);
    protected portList: BehaviorSubject<any> = new BehaviorSubject([]);

    private busy: boolean;
    private previousUrl: string = '';

    constructor(private router: Router,
        private activatedRoute: ActivatedRoute,
        private completerService: CompleterService,
        private renderer2: Renderer2,
        private portService: PortService,
        private authService: AuthService) {

        this.slug = new Slug('');
    }

    ngOnInit() {
        this.busy = true;
        this.populateDropdowns();

        EmitterService.get('AddPmoDialogComponent').subscribe(data => {
            if (data) {
                this.populateDropdowns();
            }
        });

        EmitterService.get('AddPortDialogComponent').subscribe(data => {
            if (data) {
                this.populateDropdowns();
            }
        });
    }

    private firstRun: boolean = false;
    populateDropdowns() {
        this.portService.getPmoAndPorts().subscribe((response) => {
            this.pmoList.next(response.json().Result.Offices);
            this.portList.next(null);

            // Initialize completer data once only
            if (!this.firstRun) {
                this.firstRun = true;
                this.pmoData = new CustomCompleterData(this.pmoList, 'Title');
                this.portData = new CustomCompleterData(this.portList, 'Title');
            }

            // Reset selections
            if (this.pmoData.hasItems()) {
                this.pmoData.search('');
                this.pmo = null;

                if (this.portData.hasItems()) {
                    this.portData.search('');
                    this.port = null;
                }
            }
        });
    }

    pmoSelected(item: CompleterItem) {
        if (item == null) {
            return;
        }

        const pmo = item.originalObject;
        this.selectedPmo = pmo;

        // Update observable
        this.portList.next(pmo.Ports);

        // Force clear dropdown and pre-selected data
        if (pmo.Ports && pmo.Ports.length > 0) {
            this.portCompleter.disableInput = false;
            this.portData.search('');
            this.port = null;
            this.portCompleter.focus();
        } else {
            this.portCompleter.disableInput = true;
        }
    }

    portSelected(item: CompleterItem) {
        this.selectedPort = item.originalObject;
    }

    navigateToPort() {
        let targetId = this.selectedPort.Id;
        let targetSlug = this.slug.slugify(this.selectedPort.Title);
        this.router.navigate(['/', targetId, targetSlug, 'map', new Date().getFullYear(), 'planning']);
    }
}



// WEBPACK FOOTER //
// ./Angular/app/home/home.component.ts